import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { promoCodeQKeys } from "@hooks/queries/promocodes/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { UpdatePromoCodeData } from "@customTypes/promoCode";


export const useUpdatePromoCode = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ originalCode, code, ...promoCodeData }: UpdatePromoCodeData) => {
      return api.put(`promocodes/${originalCode}`, {
        code: code, // New code value from form in request body
        discount_percent: promoCodeData.discountPercent,
        valid_from: promoCodeData.validFrom.toISOString(),
        valid_until: promoCodeData.validUntil.toISOString(),
        services: promoCodeData.services,
        medical_professional: promoCodeData.medicalProfessional,
        max_uses: promoCodeData.maxUses,
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "update-promo-code-success",
      });

      // Invalidate promo codes query to refetch the updated list
      queryClient.invalidateQueries({
        queryKey: promoCodeQKeys.all(),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Promo Code]", res);
      handleErrors(res, "mutation");
    },
  });
};
